import "@vendor/scripts/modernizr";
import "scrollit";

import init from "../sites/gmis_2019/index";

init();
